import { render, staticRenderFns } from "./ProfilAsosiasi.vue?vue&type=template&id=6fe7f626"
import script from "./ProfilAsosiasi.vue?vue&type=script&lang=js"
export * from "./ProfilAsosiasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports